import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient, withFetch } from '@angular/common/http';

bootstrapApplication(AppComponent, {...appConfig,
  providers: [
    // Primero, los providers que ya tenga appConfig (si existieran)
    ...(appConfig.providers ?? []),

    // Luego, agregamos fetch
    provideHttpClient(withFetch())
  ]
})
  .catch((err) => console.error(err));